export {
  default as SchoolDetailsHeader,
  SchoolDetailsHeaderCompact,
  SchoolDetailsHeaderMinimal,
  SchoolDetailsSavedSchools,
} from "@/components/shared/school/school-details/school-details-header";
export {
  SchoolLinkTarget,
  default as SchoolNameLink,
} from "@/components/shared/school/school-details/school-name-link";
